import { atom } from 'recoil';

export type ProjectionMode = 'perspective' | 'orthographic';

export const projectionModeState = atom<ProjectionMode>({
  key: 'projectionModeState',
  default: 'perspective',
});
